<!-- Temp Wrapping DIVs -->
<div class="upcoming-tournaments-wrapper">
    <div class="upcoming-tournaments-items">
        <div
            *ngFor="let tournament of activetournamentsItems | slice: 0 : item.itemCount; let tournamentIndex = index"
            [class]="item.widgetClass ? item.widgetClass : 'card shadow-sm mb-3'">
            <div class="card-body" *ngIf="!tournament.isHidden">
                <h6
                    class="font-weight-bold mt-0 mb-2 text-uppercase up-tournament-title"
                    (click)="openClient(tournament); pkUpcomingTornamentsLWComponentTracking(tournament)">
                    {{ tournament.name | removeColorCodesPipe }}<span class="theme-right">&nbsp;</span>
                </h6>
                <span class="tournament-tag text-uppercase">{{ tournament.gameType | gameTypePipe }}</span>
                <div class="row">
                    <div class="col-auto">
                        <strong class="tournament-sub-title">{{ widgetConfig.limit }}</strong>
                        <span class="tournament-sub-text">{{ tournament.limitType | limitNamePipe }}</span>
                    </div>
                    <div class="col-auto">
                        <strong class="tournament-sub-title">{{ widgetConfig.buyIn }}</strong>
                        <span class="tournament-sub-text tournament-buyin-text" *ngIf="!contentIivtDataSource">
                            {{ tournament.buyIn.monetaryType | formatCurrencyPipe: tournament.buyIn.unit }} +
                            {{ tournament.fee.monetaryType | formatCurrencyPipe: tournament.fee.unit }}
                        </span>
                        <span class="tournament-sub-text tournament-buyin-text" *ngIf="contentIivtDataSource">
                            {{ tournament.buyIn }}
                        </span>
                    </div>
                    <div class="col-auto">
                        <strong class="tournament-sub-title">{{ widgetConfig.players }}</strong>
                        <span class="tournament-sub-text" *ngIf="!contentIivtDataSource">{{ tournament.registeredPlayers }}</span>
                        <span class="tournament-sub-text" *ngIf="contentIivtDataSource">{{ tournament.regPlayersCount }}</span>
                    </div>
                    <div class="col-auto pr-md-0">
                        <strong class="tournament-sub-title">{{ widgetConfig.start }}</strong>
                        <pt-tournament-calendar-timer [endTime]="tournament.startDate"></pt-tournament-calendar-timer>
                    </div>
                    <div class="col-sm-4 ml-auto text text-right">
                        <button
                            class="btn btn-dark btn-sm test-uppercase mt-2"
                            (click)="openClient(tournament); pkUpcomingTornamentsLWComponentTracking(tournament)">
                            {{ widgetConfig.register }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-right" *ngIf="item.cta">
            <button class="btn btn-primary" (click)="viewAllTournaments()">{{ item.cta + totalTournamentsCount }}</button>
        </div>
    </div>
</div>
